import { registerOptionsSchema as We, resetPasswordOptionsSchema as Ue, updateCustomerOptionsSchema as Ve, centraSubscribeToBackInStockOptionsSchema as He, shippingMethodModelSchema as Ke, centraCheckoutApiProductSchema as $e, centraCheckoutApiBundleProductSchema as Qe, centraSubscribeToNewsletterOptionsSchema as Ye, centraGetProductsPayloadSchema as Je } from "@made-people/centra-checkout-api";
import { jsx as u, jsxs as A, Fragment as I } from "react/jsx-runtime";
import { AutoCompleteProvider as Ze, useGlobalSearchSettings as H, emptySearchResult as ue, useCurrentPaginationPage as Xe, CachedSearchResultsProvider as et } from "@made-people/grease-search";
import { createContext as _, useContext as T, useState as b, useEffect as N, useMemo as B, Children as tt, useCallback as le, useRef as R, useReducer as nt } from "react";
import { z as d } from "zod";
import { CartProvider as rt, useCartMethod as ot } from "@made-people/grease-cart";
import { withManagedProps as w } from "@made-people/managed-props";
import { withZod as P } from "@made-people/react-prop-guard";
import { useEffectOnce as O } from "@made-people/react-use-effect-once";
import { useCheckoutEventEmitter as j, checkoutEventEmitter as it, CheckoutEventEmitterContext as st } from "@made-people/grease-checkout";
import { isEmailAddress as oe } from "@made-people/types-email-address";
import { useOrderEventAdditionalData as at, orderEventEmitter as ct } from "@made-people/grease-order";
import { isNotUndefined as q, isArray as de } from "@made-people/typeguards-common";
async function ut(e, t, n, r) {
  if (!t.email || !t.password)
    throw new Error("Email and password are required");
  const { success: o, error: i } = await e.login(
    t.email,
    t.password
  );
  return o ? (r == null || r(o), o.loggedIn ? {
    customer: n(o.loggedIn)
  } : (console.warn(
    "Unexpected response from Centra login, user could not be logged in"
  ), {
    customer: void 0
  })) : {
    customer: void 0
  };
}
async function lt(e, t, n, r) {
  const { email: o, password: i, firstName: s, lastName: a, attributes: c } = t, l = {
    email: o,
    password: i,
    firstName: s,
    lastName: a,
    ...c
  }, m = We.safeParse(l);
  if (!m.success)
    throw new Error(m.error.errors.toString());
  const { success: h, error: p } = await e.register(m.data);
  if (h) {
    if (r == null || r(h), !h.loggedIn)
      throw new Error("Unexpected response from register");
    return {
      success: !0,
      data: { customer: n(h.loggedIn) }
    };
  } else {
    if (Object.values(p.errors).includes("already registered"))
      return {
        success: !1,
        error: "Account_EmailAlreadyExists"
      };
    throw p;
  }
}
async function dt(e, t) {
  const { success: n, error: r } = await e.getCustomerOrders();
  if (n) {
    const o = [];
    return await Promise.all(
      n.orders.map(async (i) => {
        const s = i.items.filter((c) => !!c.bundle).map((c) => c.product.product), a = [];
        if (s.length > 0) {
          const c = await Promise.all(
            s.map(
              async (l) => await e.getBundle({ id: l })
            )
          );
          for (const l of c)
            l.success && a.push(l.success);
        }
        o.push(t(i, a));
      })
    ), {
      orders: o
    };
  } else
    return {
      orders: []
    };
}
async function ht(e, t, n) {
  const { newPassword: r } = t, o = Ue.safeParse({
    newPassword: r,
    ...n
  });
  if (!o.success)
    throw new Error(o.error.errors.toString());
  const { error: i } = await e.resetPassword(o.data);
  if (i)
    throw new Error(i.errors.toString());
}
async function mt(e, t, n) {
  const { email: r } = t;
  try {
    await e.sendResetPasswordEmail(r, n);
  } catch (o) {
    console.error("sendResetPasswordEmail", o);
  }
}
async function pt(e, t) {
  try {
    const { success: n, error: r } = await e.logout();
    n && (t == null || t(n));
  } catch {
  }
  return {
    customer: void 0
  };
}
async function ft(e, t) {
  try {
    const { success: n, error: r } = await e.getCustomerData();
    return n ? {
      customer: t(n)
    } : {
      customer: void 0
    };
  } catch (n) {
    return console.error("fetchCustomer", n), {
      customer: void 0
    };
  }
}
async function yt(e, t, n) {
  var s, a, c, l, m, h, p;
  const { customer: r } = t, o = Object.fromEntries(
    Object.entries({
      firstName: (r == null ? void 0 : r.firstName) || "",
      lastName: (r == null ? void 0 : r.lastName) || "",
      address1: ((s = r == null ? void 0 : r.addresses[0]) == null ? void 0 : s.street) || "",
      address2: ((a = r == null ? void 0 : r.addresses[0]) == null ? void 0 : a.street2) || "",
      city: ((c = r == null ? void 0 : r.addresses[0]) == null ? void 0 : c.city) || "",
      state: ((l = r == null ? void 0 : r.addresses[0]) == null ? void 0 : l.state) || "",
      zipCode: ((m = r == null ? void 0 : r.addresses[0]) == null ? void 0 : m.zipCode) || "",
      country: ((h = r == null ? void 0 : r.addresses[0]) == null ? void 0 : h.country) || "",
      phoneNumber: ((p = r == null ? void 0 : r.addresses[0]) == null ? void 0 : p.phoneNumber) || ""
    }).filter(([f, C]) => C !== "")
  ), i = Ve.safeParse(
    o
  );
  if (!i.success)
    throw new Error(i.error.errors.toString());
  try {
    const { success: f, error: C } = await e.updateCustomerInfo(i.data);
    if (f) {
      if (!f.loggedIn)
        throw new Error("Unexpected response from register");
      return {
        customer: n(f.loggedIn)
      };
    } else
      throw C;
  } catch (f) {
    throw f;
  }
}
class Ar {
  constructor(t, n, r) {
    this.client = t, this.mappers = n, this.options = r;
  }
  getToken() {
    var t;
    return (t = this.client.getTokenHandler()) == null ? void 0 : t.getToken();
  }
  async login(t) {
    return ut(
      this.client,
      t,
      this.mappers.customerMapper,
      this.options.onSelectionResponse
    );
  }
  async logout() {
    return pt(this.client, this.options.onSelectionResponse);
  }
  async register(t) {
    return lt(
      this.client,
      t,
      this.mappers.customerMapper,
      this.options.onSelectionResponse
    );
  }
  async fetchOrders() {
    return dt(this.client, this.mappers.orderMapper);
  }
  async resetPassword(t) {
    return ht(this.client, t, this.options.resetPasswordData);
  }
  async sendResetPasswordEmail(t) {
    return mt(
      this.client,
      t,
      this.options.resetPasswordUri
    );
  }
  async fetchCustomer() {
    return ft(this.client, this.mappers.customerMapper);
  }
  async updateCustomer(t) {
    return yt(this.client, t, this.mappers.customerMapper);
  }
}
class Ct {
  constructor(t, n) {
    this.client = t, this.productMapper = n, this.search = async (r) => {
      const { success: o, error: i } = await this.client.getProducts({
        search: r.searchQuery,
        limit: r.limit
      });
      if (i)
        throw i;
      return {
        productSuggestions: o.products.map(
          (s) => this.productMapper(s)
        )
      };
    };
  }
}
d.object({
  market: d.string(),
  pricelist: d.string(),
  language: d.string(),
  site: d.object({
    baseUrl: d.string(),
    slug: d.string()
  }).optional()
});
const he = _(
  void 0
);
function v() {
  const e = T(he);
  if (!e)
    throw new Error("useCentraContext must be used within a CentraProvider");
  return e;
}
const Sr = (e) => {
  const { checkoutAPIClient: t, mappers: n } = v(), r = {
    autoCompleteClient: new Ct(
      t,
      n.product
    )
  };
  return /* @__PURE__ */ u(Ze, { ...r, children: e.children });
};
class wr {
  constructor(t, n) {
    this.client = t, this.defaultOptions = n;
  }
  createCentraOptions(t = {}) {
    const n = He.safeParse({
      ...this.defaultOptions,
      ...t
    });
    if (!n.success)
      throw new Error(
        `[CentraBackInStockClient]: Invalid input data for Centra back in stock, ${JSON.stringify(
          n.error.errors
        )}`
      );
    return n.data;
  }
  async subscribe(t) {
    await this.client.subscribeToBackInStock(
      t.email,
      t.subscribeItemId,
      this.createCentraOptions(t.attributes)
    );
  }
}
const me = async (e, t) => {
  const n = [];
  if (e.length > 0) {
    const r = await Promise.all(
      e.map(async (o) => await t.getBundle({ id: o }))
    );
    for (const o of r)
      o.success && n.push(o.success);
  }
  return n;
}, Nr = (e, t) => {
  const { checkoutAPIClient: n } = v(), [r, o] = b(!1), [i, s] = b(void 0), [a, c] = b(
    void 0
  );
  return N(() => {
    (async () => {
      if (!t)
        return;
      o(!0);
      const { success: m, error: h } = await n.getBundle({
        id: e
      });
      m ? s(m) : c(h), o(!1);
    })();
  }, [t, e]), {
    bundleResponse: i,
    loading: r,
    error: a
  };
};
class gt {
  constructor(t, n, r, o) {
    this.client = t, this.onSuccess = n, this.cartMapper = r, this.context = o, this.fetchCart = async () => this.client.getSelection().then(async (i) => await this.handleSelectionResponse(i)), this.addBundleToCart = async (i) => this.client.postBundle({
      item: i.itemId,
      sections: i.sections.map((s) => ({
        section: s.sectionId,
        item: s.itemId
      }))
    }).then(async (s) => await this.handleSelectionResponse(s)), this.addToCart = async (i) => {
      let s;
      return this.context.site && (s = `${this.context.site.baseUrl}/${this.context.site.slug}/${i.product.slug}`), this.client.postItem({
        itemId: i.itemId,
        quantity: i.quantity ?? 1,
        productUrl: s
      }).then(async (a) => await this.handleSelectionResponse(a));
    }, this.removeFromCart = async (i) => this.client.deleteItem({
      lineId: i.lineId,
      quantity: i.quantity
    }).then(async (s) => await this.handleSelectionResponse(s)), this.updateQuantity = async (i) => this.client.updateItem({
      lineId: i.lineId,
      quantity: i.quantity
    }).then(async (s) => await this.handleSelectionResponse(s)), this.updateComment = async () => {
      throw new Error("Not Implemented");
    }, this.addVoucher = async (i) => this.client.postVouchers(i.voucherCode).then((s) => this.handleSelectionResponse(s)), this.removeVoucher = async (i) => this.client.deleteVouchers(i.voucherCode).then((s) => this.handleSelectionResponse(s));
  }
  async handleSelectionResponse({
    success: t,
    error: n
  }) {
    if (t) {
      this.onSuccess(t);
      const r = t.selection.items.filter(
        (i) => {
          var s;
          return i.bundle && ((s = i.product.bundleInfo) == null ? void 0 : s.type) === "flexible";
        }
      ).map((i) => i.product.product), o = await me(r, this.client);
      return this.cartMapper(t, o);
    }
    throw n;
  }
}
const pe = _(
  void 0
), fe = _(void 0);
function ye() {
  const e = T(pe);
  if (!e)
    throw new Error(
      "useCentraReducerState must be used within a CentraProvider"
    );
  return e;
}
function W() {
  const e = T(fe);
  if (!e)
    throw new Error(
      "useCentraReducerDispatch must be used within a CentraProvider"
    );
  return e;
}
function k() {
  return ye().selectionResponse;
}
const bt = async (e, t) => {
  const n = e.items.filter(
    (r) => {
      var o;
      return !r.bundle && ((o = r.product.bundleInfo) == null ? void 0 : o.type) === "flexible";
    }
  ).map((r) => r.product.product);
  return me(n, t);
}, Ce = (e) => {
  const { checkoutAPIClient: t, mappers: n, queryContext: r } = v(), { selectionResponse: o } = ye(), i = W(), [s, a] = b(void 0);
  N(() => {
    o && bt(o.selection, t).then(
      (l) => {
        a(n.cart(o, l));
      }
    );
  }, [o]);
  const c = B(
    () => new gt(
      t,
      (l) => i({
        type: "SET_SELECTION_RESPONSE",
        payload: { selectionResponse: l }
      }),
      n.cart,
      r
    ),
    [t, n.cart]
  );
  return /* @__PURE__ */ u(rt, { initialCart: s, cartClientDriver: c, children: e.children });
};
Ce.displayName = "CentraGreaseCartProvider";
const Pt = d.object({
  paymentReturnPage: d.custom(),
  paymentFailedPage: d.custom(),
  /**
   * This is a function that returns additional notes to be sent in the
   * POST payment request and ultimately stored on the Centra order.
   */
  additionalNotesGetter: d.function().args().returns(
    d.union([d.record(d.string(), d.unknown()), d.string(), d.undefined()])
  ).optional(),
  /**
   * This is a function that returns additional fields to be sent in the
   * payment fields update and payment requests.
   */
  additionalFieldsGetter: d.function().args().returns(d.union([d.record(d.string(), d.unknown()), d.undefined()])).optional(),
  /**
   * When enabled, the shipping address received from the payment widget's
   * shipping address callback is sent to Centra via payment-fields so that
   * totals and taxes are recalculated. Off by default since it triggers an
   * extra selection update, which suspends and resumes the checkout iframe.
   */
  sendShippingAddressToPaymentFields: d.boolean().optional(),
  visitorIpAddress: d.union([
    d.function().returns(d.promise(d.union([d.string().ip(), d.undefined()]))),
    d.string().ip()
  ]).optional()
}), K = _(void 0), vt = (e) => /* @__PURE__ */ u(K.Provider, { value: e.value, children: e.children }), $ = () => {
  const e = T(K);
  if (!e)
    throw new Error(
      "useCentraCheckout must be used within CentraCheckoutProvider"
    );
  return e;
}, kt = d.object({}), Er = w(
  "CentraCheckoutError",
  P(kt, (e) => null)
);
function At(e) {
  return e !== null && typeof e == "object" && "tagName" in e && e.tagName === "SCRIPT";
}
const St = (e) => {
  var n, r;
  const t = document.createElement("script");
  t.text = e.innerHTML;
  for (let o = e.attributes.length - 1; o >= 0; o--) {
    const i = (n = e.attributes[o]) == null ? void 0 : n.name, s = (r = e.attributes[o]) == null ? void 0 : r.value;
    i && s && t.setAttribute(i, s);
  }
  return t;
}, ge = (e) => {
  if (At(e))
    e.parentNode && e.parentNode.replaceChild(St(e), e);
  else {
    const t = e.childNodes;
    for (const n of t)
      n && ge(n);
  }
  return e;
}, be = _(null), z = (e) => {
  const [t, n] = b(0), r = tt.count(e.children), o = t === r, i = le(() => {
    n((s) => s + 1);
  }, []);
  return /* @__PURE__ */ A(I, { children: [
    /* @__PURE__ */ u(be.Provider, { value: i, children: e.children }),
    o && e.component
  ] });
}, Q = () => T(be), F = (e) => {
  const t = Q(), n = R(null);
  return O(() => {
    t && t();
  }), N(() => {
    n.current && (n.current.innerHTML = e.html, ge(n.current), e.onLoad && e.onLoad());
  }, [e.html]), /* @__PURE__ */ u("div", { style: { width: "100%" }, ref: n });
};
function Y(e) {
  return e !== null && typeof e == "object" && "formHtml" in e && typeof e.formHtml == "string" && "action" in e && e.action === "form";
}
const Pe = _(void 0);
function J() {
  const e = T(Pe);
  if (!e)
    throw new Error(
      "useCentraPaymentInitialize must be used within a CentraPaymentInitialize"
    );
  return e;
}
const wt = () => /* @__PURE__ */ u("p", { children: "At least one shipping method must be configured in your Centra instance." }), Nt = (e) => /* @__PURE__ */ u("li", { children: /* @__PURE__ */ A("label", { children: [
  e.loading && /* @__PURE__ */ u("span", { children: "Loading..." }),
  /* @__PURE__ */ u(
    "input",
    {
      type: "radio",
      id: e.methodKey,
      checked: e.isSelected,
      onChange: () => e.onChange(e.methodKey)
    }
  ),
  e.label,
  " (",
  e.price,
  ")"
] }) }), Et = (e) => {
  var t;
  return /* @__PURE__ */ A("div", { children: [
    /* @__PURE__ */ u("label", { children: e.label }),
    /* @__PURE__ */ u(
      "input",
      {
        required: e.required,
        value: e.value || "",
        onChange: e.onChange
      }
    ),
    (t = e.messages) == null ? void 0 : t.map((n) => /* @__PURE__ */ u("p", { children: n }))
  ] });
}, It = (e) => {
  const [t, n] = b(!0), [r, o] = b(e.address), [i, s] = b(e.shippingAddress);
  function a() {
    const h = e.validateAddress({ address: r, shippingAddress: i });
    if (h === !0) {
      e.onUpdate({ address: r, shippingAddress: i });
      return;
    }
    o(h.address), s(h.shippingAddress);
  }
  const c = (h, p) => o((f) => ({
    ...f,
    [h]: {
      ...f[h],
      value: p.target.value
    }
  })), l = (h) => {
    var f, C;
    const p = r[h];
    if (p && p.validationResult !== !0 && ((C = (f = p.validationResult) == null ? void 0 : f.messages) != null && C.length))
      return p.validationResult.messages;
  }, m = [
    {
      label: "First Name",
      value: r.firstName.value,
      onChange: (h) => c("firstName", h),
      required: r.firstName.required,
      messages: l("firstName")
    },
    {
      label: "Last Name",
      value: r.lastName.value,
      onChange: (h) => c("lastName", h),
      required: r.lastName.required,
      messages: l("lastName")
    },
    {
      label: "Email",
      value: r.email.value,
      onChange: (h) => c("email", h),
      required: r.email.required,
      messages: l("email")
    },
    {
      label: "Street",
      value: r.street.value,
      onChange: (h) => c("street", h),
      required: r.street.required,
      messages: l("street")
    },
    {
      label: "Zip Code",
      value: r.zipCode.value,
      onChange: (h) => c("zipCode", h),
      required: r.zipCode.required,
      messages: l("zipCode")
    },
    {
      label: "City",
      value: r.city.value,
      onChange: (h) => c("city", h),
      required: r.city.required,
      messages: l("city")
    }
  ];
  return /* @__PURE__ */ u(I, { children: t ? /* @__PURE__ */ A("div", { children: [
    m.map((h) => /* @__PURE__ */ u(Et, { ...h }, h.label)),
    /* @__PURE__ */ u("div", { children: /* @__PURE__ */ u("button", { onClick: a, children: "Update" }) })
  ] }) : /* @__PURE__ */ A(I, { children: [
    /* @__PURE__ */ A("div", { children: [
      /* @__PURE__ */ A("div", { children: [
        r.firstName.value,
        " ",
        r.lastName.value
      ] }),
      /* @__PURE__ */ u("div", { children: r.street.value }),
      /* @__PURE__ */ A("div", { children: [
        r.zipCode.value,
        " ",
        r.city.value
      ] }),
      /* @__PURE__ */ u("div", { children: r.country.selectedCountry.label })
    ] }),
    /* @__PURE__ */ u("button", { onClick: () => n(!0), children: "Edit" })
  ] }) });
}, Tt = (e) => /* @__PURE__ */ A("div", { children: [
  /* @__PURE__ */ u("h1", { children: "Select Shipping Method" }),
  /* @__PURE__ */ u("br", {}),
  e.children
] }), D = (e) => /* @__PURE__ */ u(I, { children: e.children }), Mt = (e) => /* @__PURE__ */ A("div", { children: [
  /* @__PURE__ */ u("h1", { children: "Unavailable items" }),
  /* @__PURE__ */ u("ul", { children: e.unavailableItems.map((t) => /* @__PURE__ */ A("li", { children: [
    t.product.base.content.name,
    "is unavailable. You have ",
    t.availableQuantity,
    " available and",
    " ",
    t.unavailableQuantity,
    " was removed from cart."
  ] }, t.product.base.productId)) })
] }), _t = () => /* @__PURE__ */ u("div", { children: "Payment method failed, reload checkout and try again. Make sure you're using HTTPS if you're in development mode." }), Ot = (e) => /* @__PURE__ */ u(I, { children: JSON.stringify(e.order) }), Ft = () => /* @__PURE__ */ u("div", { children: "Selection not found, go back to home" }), Rt = () => /* @__PURE__ */ u("p", { children: "Unsupported checkout flow, selected a specific one using props or configure Centra to only have one payment method per market." }), ve = _(void 0), Dt = {
  ShippingMethodsNotConfigured: wt,
  ShippingMethodOption: Nt,
  AddressForm: It,
  ShippingMethods: Tt,
  QliroWrapper: D,
  AdyenDropInWrapper: D,
  KlarnaCheckoutWrapper: D,
  IngridWrapper: D,
  StandalonePaymentWrapper: D,
  YourCartHasBeenModified: Mt,
  CartIsEmpty: () => null,
  CheckoutLoading: () => null,
  PaymentLoading: () => null,
  UnsupportedCheckoutFlow: Rt,
  UnsupportedPaymentMethod: () => null,
  UnsupportedShippingMethod: () => null,
  PaymentMethodFailed: _t,
  SelectionNotFound: Ft,
  GenericOrderReceipt: Ot,
  FreeOrder: () => null
}, Bt = (e) => ({
  ...Dt,
  ...e
}), ke = ({
  value: e,
  children: t
}) => {
  const n = {
    components: Bt(e == null ? void 0 : e.components)
  };
  return /* @__PURE__ */ u(ve.Provider, { value: n, children: t });
};
function S() {
  const e = T(ve);
  if (!e)
    throw new Error(
      "useCentraCheckoutUiConfig must be used within a CentraCheckoutUiConfigProvider"
    );
  return e;
}
const Gt = d.object({}), qt = P(
  Gt,
  (e) => {
    const t = k(), n = J(), [r, o] = b(null), [i, s] = b(0), a = R(null), {
      components: { KlarnaCheckoutWrapper: c }
    } = S();
    return N(() => {
      var m;
      if (!t)
        return;
      const l = (m = t.selection.pluginFields) == null ? void 0 : m.paymentHTML;
      l ? l !== a.current && (a.current = l, o(l), s((h) => h + 1)) : n && Y(n) && o(n.formHtml);
    }, [t, n]), r === null ? null : /* @__PURE__ */ u(c, { children: /* @__PURE__ */ u(F, { html: r }, i) });
  }
), xt = d.object({}), zt = P(
  xt,
  () => {
    const e = k(), t = J(), [n, r] = b(null), {
      components: { QliroWrapper: o }
    } = S();
    return N(() => {
      var i, s;
      e && (window.totalPrice = (i = e == null ? void 0 : e.selection) == null ? void 0 : i.totals.grandTotalPriceAsNumber, ((s = e == null ? void 0 : e.selection) == null ? void 0 : s.qliroReplaceSnippet) === !0 && e.selection.paymentHTML ? r(e.selection.paymentHTML) : t && Y(t) && r(t.formHtml));
    }, [e]), n === null ? null : /* @__PURE__ */ u(o, { children: /* @__PURE__ */ u(F, { html: n }) });
  }
), Lt = () => {
  const e = J(), {
    components: { AdyenDropInWrapper: t }
  } = S();
  return !e || !Y(e) ? null : /* @__PURE__ */ u(t, { children: /* @__PURE__ */ u(F, { html: e.formHtml }) });
}, Ae = () => {
  const e = k();
  return e == null ? void 0 : e.paymentMethods.find(
    (t) => t.paymentMethod === (e == null ? void 0 : e.selection.paymentMethod)
  );
}, jt = "checkout_started_session", Z = "add_shipping_info_session", Wt = "add_payment_info_session", U = ({
  sessionKey: e,
  prerequisiteKey: t
}) => {
  const n = R(!1);
  return { trackOnce: le(
    (o) => {
      if (n.current || t && !sessionStorage.getItem(t))
        return;
      if (sessionStorage.getItem(e)) {
        n.current = !0;
        return;
      }
      n.current = !0, sessionStorage.setItem(
        e,
        JSON.stringify({ timestamp: Date.now() })
      ), o();
    },
    [e, t]
  ) };
}, Se = d.object({}), we = w(
  "CentraCheckoutPayment",
  P(Se, (e) => {
    const t = j(), n = Ae(), r = k(), { mappers: o } = v(), {
      components: { UnsupportedPaymentMethod: i, CheckoutPaymentGate: s }
    } = S(), [a, c] = b(!1), { trackOnce: l } = U({
      sessionKey: Wt,
      prerequisiteKey: Z
    });
    if (N(() => {
      !(n != null && n.paymentMethod) || !r || l(() => {
        t.eventEmitter.emit("paymentMethodSelected", {
          cart: o.cart(r, [])
        });
      });
    }, [n, r, l]), !n)
      return null;
    if (s && !a)
      return /* @__PURE__ */ u(s, { onSuccess: () => c(!0) });
    switch (n.paymentMethodType) {
      case "klarna_checkout":
        return /* @__PURE__ */ u(qt, {});
      case "qliro":
        return /* @__PURE__ */ u(zt, {});
      case "adyen_drop_in":
        return /* @__PURE__ */ u(Lt, {});
      default:
        return /* @__PURE__ */ u(i, {});
    }
  })
), Ut = d.object({
  method: Ke
}), Vt = P(
  Ut,
  ({ method: e }) => {
    const { checkoutAPIClient: t } = v(), n = W(), r = k(), [o, i] = b(!1), {
      components: { ShippingMethodOption: s }
    } = S();
    if (!r)
      return null;
    async function a(h) {
      i(!0);
      const { success: p, error: f } = await t.setShippingMethod({
        shippingMethod: h
      }).finally(() => i(!1));
      p ? n({
        type: "SET_SELECTION_RESPONSE",
        payload: { selectionResponse: p }
      }) : console.error(f);
    }
    const c = r.selection.shippingMethod === e.shippingMethod, m = !!r.selection.discounts.automaticDiscounts.find(
      (h) => {
        var p;
        return (p = h.freeShippingFor) == null ? void 0 : p.includes(e.shippingMethod);
      }
    );
    return /* @__PURE__ */ u(
      s,
      {
        methodKey: e.shippingMethod,
        label: e.name,
        loading: o,
        price: e.price,
        priceNumber: e.priceAsNumber,
        isSelected: c,
        onChange: a,
        isFreeShipping: m
      }
    );
  }
), Ht = d.object({}), Kt = P(
  Ht,
  () => {
    const { mappers: e } = v(), t = j(), n = k(), r = Q(), {
      components: { ShippingMethods: o, ShippingMethodsNotConfigured: i }
    } = S(), { trackOnce: s } = U({
      sessionKey: Z
    });
    O(() => {
      r && r();
    });
    const a = n == null ? void 0 : n.selection.shippingMethod;
    return N(() => {
      !a || !n || s(() => {
        t.eventEmitter.emit("shippingMethodSelected", {
          cart: e.cart(n)
        });
      });
    }, [a, n, s]), n ? n.shippingMethods.length === 0 ? /* @__PURE__ */ u(i, {}) : /* @__PURE__ */ u(o, { children: n.shippingMethods.map((c) => /* @__PURE__ */ u(
      Vt,
      {
        method: c
      },
      c.shippingMethod
    )) }) : null;
  }
), $t = d.object({}), Qt = P(
  $t,
  () => {
    var h, p;
    const e = j(), t = k(), { mappers: n } = v(), r = R(!1), { trackOnce: o } = U({
      sessionKey: Z
    }), {
      components: { ShippingMethodsNotConfigured: i, IngridWrapper: s }
    } = S(), [a, c] = b(!0), l = ((h = t == null ? void 0 : t.selection.pluginFields) == null ? void 0 : h.ingrid) ?? // Ingrid V2
    ((p = t == null ? void 0 : t.selection.pluginFields) == null ? void 0 : p.shipwallet), m = (f, C) => {
      !t || !C.shipping_method_changed || o(() => {
        const g = {
          code: f.shipping_method,
          name: f.shipping_method
        };
        e.eventEmitter.emit("shippingMethodSelected", {
          cart: {
            ...n.cart(t),
            shippingMethod: g
          }
        });
      });
    };
    return N(() => {
      r.current || (r.current = !0, !(!(l != null && l.snippet) || !t || !window._sw) && window._sw(function(f) {
        f.on("data_changed", m);
      }));
    }, [l, t]), l != null && l.deliveryOptionsAvailable ? !a || !l.snippet ? null : /* @__PURE__ */ u(s, { children: /* @__PURE__ */ u(F, { html: l.snippet }) }) : /* @__PURE__ */ u(i, {});
  }
), Yt = () => {
  var n, r, o, i, s;
  const e = k();
  return ((s = ((r = (n = e == null ? void 0 : e.selection) == null ? void 0 : n.pluginFields) == null ? void 0 : r.ingrid) ?? ((i = (o = e == null ? void 0 : e.selection) == null ? void 0 : o.pluginFields) == null ? void 0 : i.shipwallet)) == null ? void 0 : s.deliveryOptionsAvailable) === !0 ? "ingrid" : "centra";
}, Jt = d.object({}), L = w(
  "CentraCheckoutShipping",
  P(Jt, () => {
    const e = Yt(), {
      components: { UnsupportedShippingMethod: t, CentraShippingMethodsRenderer: n }
    } = S(), r = n ?? Kt;
    switch (e) {
      case "ingrid":
        return /* @__PURE__ */ u(Qt, {});
      case "centra":
        return /* @__PURE__ */ u(r, {});
      default:
        return /* @__PURE__ */ u(t, {});
    }
  })
), Ne = async (e, t) => {
  switch (e.action) {
    case "success": {
      const n = e == null ? void 0 : e.order, r = new CustomEvent("centra_checkout_payment_response", {
        detail: {
          action: null,
          resultCode: (n == null ? void 0 : n.resultCode) ?? null
        }
      });
      document.dispatchEvent(r);
      const o = window.location.href;
      setTimeout(() => {
        window.location.href === o && (window.location.href = t);
      }, 2e3);
      break;
    }
    case "redirect":
      e.url && (window.location.href = e.url);
      break;
    case "javascript": {
      const n = new CustomEvent("centra_checkout_payment_response", {
        detail: e.formFields
      });
      document.dispatchEvent(n);
      break;
    }
  }
};
async function Zt(e, t, n, r) {
  if (!n.detail)
    return;
  let o = {
    paymentMethodSpecificFields: n.detail.paymentMethodSpecificFields,
    paymentMethod: n.detail.paymentMethod
  };
  const s = {
    ...r == null ? void 0 : r(),
    ...n.detail.additionalFields
  };
  n.detail.addressIncluded && (o = {
    ...o,
    address: n.detail.billingAddress,
    shippingAddress: n.detail.shippingAddress,
    additionalFields: s
  });
  try {
    const { success: a, error: c } = await e(o);
    if (!a)
      throw c;
    Ne(a, t);
  } catch (a) {
    console.error(a);
  }
}
async function Xt(e, t, n) {
  var s, a;
  if (!t.detail)
    return;
  const o = {
    ...n == null ? void 0 : n(),
    ...t.detail.additionalFields
  }, i = {
    ...t.detail,
    additionalFields: o
  };
  await e(i), (a = window.CentraCheckout) == null || a.resume((s = t.detail.additionalFields) == null ? void 0 : s.suspendIgnore);
}
const V = () => {
  const { checkoutAPIClient: e } = v(), t = $(), n = k();
  function r(o, i) {
    return typeof o == "function" ? o(i) : o;
  }
  return async (o) => {
    if (n === void 0)
      throw new Error(
        "Selection not fetched, please verify your implementation"
      );
    const i = o ?? {};
    if (t.additionalNotesGetter) {
      const s = await t.additionalNotesGetter();
      if (typeof s == "string" && (i.additionalNotes = s), typeof s == "object" && s !== null)
        try {
          i.additionalNotes = JSON.stringify(s);
        } catch {
          console.error(
            "Failed to stringify additional notes for POST payment, not sending to Centra",
            { additionalNotes: s }
          );
        }
    }
    return t.visitorIpAddress && (typeof t.visitorIpAddress == "function" ? i.ipAddress = await t.visitorIpAddress().catch((s) => {
      console.error(
        "Failed to get visitor IP address for POST payment, sending undefined to Centra",
        { error: s }
      );
    }) : i.ipAddress = t.visitorIpAddress), await e.postPayment({
      paymentReturnPage: r(
        t.paymentReturnPage,
        n
      ),
      paymentFailedPage: r(
        t.paymentFailedPage,
        n
      ),
      address: n.selection.address,
      shippingAddress: n.selection.shippingAddress,
      ...i
    });
  };
}, en = () => {
  const e = T(K);
  return B(() => {
    if (e != null && e.additionalFieldsGetter)
      return e.additionalFieldsGetter();
  }, [e == null ? void 0 : e.additionalFieldsGetter]);
}, Ee = () => {
  const e = W(), { checkoutAPIClient: t } = v(), n = en();
  return async (r) => {
    const o = {
      ...r,
      additionalFields: {
        ...r.additionalFields ?? {},
        ...n
      }
    }, { success: i, error: s } = await t.paymentFieldsUpdate(o);
    if (i)
      return e({
        type: "SET_SELECTION_RESPONSE",
        payload: {
          selectionResponse: i
        }
      }), i;
    throw s;
  };
};
function Ie(e, t) {
  if (t === void 0)
    throw new Error("Selection not fetched, please verify your implementation");
  return typeof e == "function" ? e(t) : e;
}
function Te(e, t) {
  let n = {};
  t && t.selection && t.selection.totals ? n = {
    country: t.location.country,
    currency: t.selection.currency,
    currencyDenominator: t.selection.currencyFormat.denominator,
    grandTotalPriceAsNumber: t.selection.totals.grandTotalPriceAsNumber,
    shippingMethod: t.selection.shippingMethod,
    shippingMethodsAvailable: t.shippingMethods
  } : n = {
    error: !0
  };
  const r = new CustomEvent(e, {
    detail: n
  });
  document.dispatchEvent(r);
}
const ie = "centra_checkout_shipping_address_callback";
function tn(e, t, n) {
  return async (r) => {
    if (!r.detail)
      return;
    const { shippingCountry: o, shippingState: i, shippingZipCode: s, shippingCity: a } = r.detail, { success: c, error: l } = await e.setCountry(
      o,
      i
    );
    if (l)
      throw new Error(
        `Couldn't set country to '${o}'${i ? `, or state to '${i}'` : ""}`
      );
    let m = c;
    if (n && (s || a))
      try {
        m = await t({
          shippingAddress: {
            country: o,
            state: i,
            zipCode: s,
            city: a
          }
        });
      } catch (h) {
        console.error(
          `Couldn't update payment fields with the shipping address for '${o}'`,
          h
        );
      }
    Te(
      "centra_checkout_shipping_address_response",
      m
    );
  };
}
const se = "centra_checkout_shipping_method_callback";
function nn(e) {
  return async (t) => {
    if (!t.detail)
      return;
    const { shippingMethod: n } = t.detail, { success: r, error: o } = await e.setShippingMethod({
      shippingMethod: n
    });
    if (o)
      throw new Error(`Couldn't set shipping method to '${n}'`);
    Te(
      "centra_checkout_shipping_method_response",
      r
    );
  };
}
const Me = () => {
  const e = V(), t = Ee(), n = k(), { checkoutAPIClient: r } = v(), {
    paymentReturnPage: o,
    additionalFieldsGetter: i,
    sendShippingAddressToPaymentFields: s
  } = $(), a = n == null ? void 0 : n.selection.centraCheckoutScript, c = !!a, l = {
    payment: (p) => Zt(
      e,
      Ie(o, n),
      p,
      i
    ),
    checkout: (p) => Xt(t, p, i),
    shippingAddress: tn(
      r,
      t,
      s
    ),
    shippingMethod: nn(r)
  }, m = R(l);
  if (m.current = l, N(() => {
    var p, f;
    (p = window == null ? void 0 : window.CentraCheckout) == null || p.suspend(), (f = window == null ? void 0 : window.CentraCheckout) == null || f.resume();
  }, [n]), N(() => {
    if (!c)
      return;
    const p = (y) => m.current.payment(y), f = (y) => m.current.checkout(y), C = (y) => m.current.shippingAddress(
      y
    ), g = (y) => m.current.shippingMethod(
      y
    );
    return document.addEventListener(
      "centra_checkout_payment_callback",
      p
    ), document.addEventListener("centra_checkout_callback", f), document.addEventListener(
      ie,
      C
    ), document.addEventListener(
      se,
      g
    ), () => {
      document.removeEventListener(
        "centra_checkout_payment_callback",
        p
      ), document.removeEventListener(
        "centra_checkout_callback",
        f
      ), document.removeEventListener(
        ie,
        C
      ), document.removeEventListener(
        se,
        g
      );
    };
  }, [c]), !n || !n.selection.centraCheckoutScript)
    return null;
  const h = `<script>${a}<\/script>`;
  return /* @__PURE__ */ u(F, { html: h });
}, ae = (e, t) => {
  var s, a;
  const n = t.countries, r = t.location.country, o = e.country, i = n.find(
    (c) => c.country === o || c.country === r
  );
  if (!i)
    throw new Error("Country not found, this should not happen");
  return {
    email: { value: e.email, required: !0, validationResult: null },
    firstName: {
      value: e.firstName,
      required: !0,
      validationResult: null
    },
    lastName: {
      value: e.lastName,
      required: !0,
      validationResult: null
    },
    company: {
      value: e.company,
      required: !1,
      validationResult: null
    },
    street: {
      value: e.address1,
      required: !0,
      validationResult: null
    },
    zipCode: { value: e.zipCode, required: !0, validationResult: null },
    city: { value: e.city, required: !0, validationResult: null },
    country: {
      validationResult: null,
      selectedCountry: {
        label: i.name,
        value: i.country,
        stateRequired: !!((s = i.states) != null && s.length),
        selectedState: e.state ? {
          label: e.state,
          value: e.state
        } : void 0,
        states: (a = i.states) == null ? void 0 : a.map((c) => ({
          label: c.name,
          value: c.name
        }))
      },
      options: n.map((c) => {
        var l, m;
        return {
          label: c.name,
          value: c.country,
          stateRequired: !!((l = c.states) != null && l.length),
          states: (m = c.states) == null ? void 0 : m.map((h) => ({
            label: h.name,
            value: h.state
          }))
        };
      }),
      required: !0
    },
    phoneNumber: {
      value: e.phoneNumber,
      required: !0,
      validationResult: null
    },
    state: e.state ? { value: e.state, required: !0, validationResult: null } : void 0
  };
}, rn = (e) => {
  if (e.length === 0)
    return { messages: ["Checkout_Address_Phone_Number_Required"] };
  const t = /^[\d+\-()\s]+$/.test(e), n = /\d/.test(e);
  return t && n ? !0 : { messages: ["Checkout_Address_Invalid_Phone_Number"] };
}, on = ({
  address: e,
  shippingAddress: t
}) => {
  var i, s;
  const n = {
    email: {
      ...e.email,
      validationResult: oe(e.email.value) ? !0 : { messages: ["Checkout_Address_Invalid_Email"] }
    },
    firstName: {
      ...e.firstName,
      validationResult: e.firstName.value.length > 0 ? !0 : { messages: ["Checkout_Address_First_Name_Required"] }
    },
    lastName: {
      ...e.lastName,
      validationResult: e.lastName.value.length > 0 ? !0 : { messages: ["Checkout_Address_Last_Name_Required"] }
    },
    street: {
      ...e.street,
      validationResult: e.street.value.length > 0 ? !0 : { messages: ["Checkout_Address_Address_Required"] }
    },
    phoneNumber: {
      ...e.phoneNumber,
      validationResult: rn(e.phoneNumber.value)
    },
    company: {
      ...e.company,
      validationResult: !0
    },
    country: {
      ...e.country,
      validationResult: !0
    },
    city: {
      ...e.city,
      validationResult: e.city.value.length > 0 ? !0 : { messages: ["Checkout_Address_City_Required"] }
    },
    zipCode: {
      ...e.zipCode,
      validationResult: e.zipCode.value.length > 0 ? !0 : { messages: ["Checkout_Address_Zip_Code_Required"] }
    },
    state: e.country.selectedCountry.stateRequired ? {
      value: ((i = e.state) == null ? void 0 : i.value) ?? "",
      required: !0,
      validationResult: ((s = e.state) == null ? void 0 : s.value) !== void 0 && e.state.value.length > 0 ? !0 : { messages: ["Checkout_Address_State_Required"] }
    } : void 0
  }, r = {
    email: {
      ...t.email,
      validationResult: oe(t.email.value) ? !0 : { messages: ["Checkout_Address_Invalid_Email"] }
    },
    firstName: {
      ...t.firstName,
      validationResult: t.firstName.value.length > 0 ? !0 : { messages: ["Checkout_Address_First_Name_Required"] }
    },
    lastName: {
      ...t.lastName,
      validationResult: t.lastName.value.length > 0 ? !0 : { messages: ["Checkout_Address_Last_Name_Required"] }
    },
    street: {
      ...t.street,
      validationResult: t.street.value.length > 0 ? !0 : { messages: ["Checkout_Address_Address_Required"] }
    },
    phoneNumber: {
      ...t.phoneNumber,
      validationResult: t.phoneNumber.value.length > 0 ? !0 : { messages: ["Checkout_Address_Phone_Number_Required"] }
    },
    company: {
      ...t.company,
      validationResult: !0
    },
    country: {
      ...t.country,
      validationResult: !0
    },
    city: {
      ...t.city,
      validationResult: t.city.value.length > 0 ? !0 : { messages: ["Checkout_Address_City_Required"] }
    },
    zipCode: {
      ...t.zipCode,
      validationResult: t.zipCode.value.length > 0 ? !0 : { messages: ["Checkout_Address_Zip_Code_Required"] }
    },
    state: t.state && {
      ...t.state,
      validationResult: !0
    }
  };
  return Object.values(r).every(
    (a) => a === void 0 || a.validationResult === !0
  ) && Object.values(n).every(
    (a) => a === void 0 || a.validationResult === !0
  ) ? !0 : {
    address: n,
    shippingAddress: r
  };
}, sn = async ({
  address: e,
  shippingAddress: t,
  updatePaymentFields: n
}) => {
  var r, o;
  await n({
    shippingAddress: {
      email: t.email.value,
      firstName: t.firstName.value,
      lastName: t.lastName.value,
      address1: t.street.value,
      address2: "",
      // Not supported
      phoneNumber: t.phoneNumber.value,
      company: t.company.value,
      country: t.country.selectedCountry.value,
      city: t.city.value,
      zipCode: t.zipCode.value,
      state: (r = t.state) == null ? void 0 : r.value
    },
    address: {
      email: e.email.value,
      firstName: e.firstName.value,
      lastName: e.lastName.value,
      address1: e.street.value,
      address2: "",
      // Not supported
      phoneNumber: e.phoneNumber.value,
      company: e.company.value,
      country: e.country.selectedCountry.value,
      city: e.city.value,
      zipCode: e.zipCode.value,
      state: (o = e.state) == null ? void 0 : o.value
    }
  });
}, X = d.object({
  onAddressUpdate: d.custom().optional()
}), _e = w(
  "CheckoutAddressForm",
  P(X, ({ onAddressUpdate: e }) => {
    const t = k(), n = Ee(), {
      components: { AddressForm: r }
    } = S(), o = Q();
    if (O(() => {
      o && o();
    }), !t)
      return null;
    const i = async ({
      address: c,
      shippingAddress: l
    }) => {
      await sn({
        address: c,
        shippingAddress: l,
        updatePaymentFields: n
      });
      try {
        e == null || e({ address: c, shippingAddress: l });
      } catch (m) {
        console.error(
          "Error calling onAddressUpdate in CheckoutAddressForm",
          m
        );
      }
    }, s = ae(
      t.selection.address,
      t
    ), a = ae(
      t.selection.shippingAddress,
      t
    );
    return /* @__PURE__ */ u(
      r,
      {
        address: s,
        shippingAddress: a,
        validateAddress: on,
        onUpdate: i
      }
    );
  })
), ee = (e) => {
  const t = k(), n = t == null ? void 0 : t.paymentMethods;
  if (!n)
    return null;
  const r = n.find(
    (o) => o.paymentMethod === e
  ) ?? n[0];
  return r ? !r.providesCustomerAddressAfterPayment : null;
}, Oe = (e) => {
  const t = ee(e), n = k();
  if (!n)
    return !1;
  if (!t)
    return !0;
  const r = n.selection.shippingAddress;
  return [
    r.firstName,
    r.lastName,
    r.address1,
    r.zipCode,
    r.city,
    r.country
  ].every(Boolean);
};
function an(e) {
  var t;
  return "errors" in e && ((t = e.errors) == null ? void 0 : t.selection) === "not found";
}
function Fe(e) {
  var t;
  return "errors" in e && ((t = e.errors) == null ? void 0 : t.paymentMethod) === "failed";
}
function cn(e) {
  var t;
  return "errors" in e && ((t = e.errors) == null ? void 0 : t.stock) === "unavailable_items" && "unavailableItems" in e;
}
const un = ({
  error: e
}) => {
  var o;
  const { mappers: t } = v(), {
    components: { YourCartHasBeenModified: n, PaymentMethodFailed: r }
  } = S();
  return cn(e) ? /* @__PURE__ */ u(
    n,
    {
      unavailableItems: ((o = e.unavailableItems) == null ? void 0 : o.map((i) => ({
        availableQuantity: i.available,
        unavailableQuantity: i.unavailable,
        originalQuantity: i.originalQuantity,
        product: t.product(i.product)
      }))) ?? []
    }
  ) : Fe(e) ? /* @__PURE__ */ u(r, {}) : null;
};
async function Re(e, t) {
  const { success: n, error: r } = await e.getSelection();
  if (n)
    t({
      type: "SET_SELECTION_RESPONSE",
      payload: {
        selectionResponse: n
      }
    });
  else
    throw r;
}
const ln = () => {
  const e = W(), { checkoutAPIClient: t } = v();
  return () => Re(t, e);
}, te = d.object({
  children: d.custom(),
  paymentMethod: d.string().optional().describe(
    "The payment method uri to use instead of the one Centra pre-selects"
  )
}), De = w(
  "CentraPaymentInitialize",
  P(te, (e) => {
    const [t, n] = b(null), r = ln(), o = V(), [i, s] = b(null), {
      components: { PaymentLoading: a }
    } = S();
    if (O(() => {
      async function c() {
        const l = {};
        e.paymentMethod && (l.paymentMethod = e.paymentMethod);
        const { success: m, error: h } = await o(l);
        m ? (await r(), n(m)) : s(h);
      }
      c();
    }), !t && !i)
      return /* @__PURE__ */ u(a, {});
    if (t)
      return /* @__PURE__ */ u(Pe.Provider, { value: t, children: e.children });
    if (i)
      return /* @__PURE__ */ u(un, { error: i });
  })
), Be = () => {
  const e = k(), t = Ae();
  return (e == null ? void 0 : e.selection.totals.grandTotalPriceAsNumber) === 0 && (t == null ? void 0 : t.paymentMethodType) === "adyen_drop_in";
}, Ge = () => {
  const e = V(), {
    components: { FreeOrder: t }
  } = S(), { paymentReturnPage: n } = $(), r = k();
  return /* @__PURE__ */ u(t, { placeOrder: async () => {
    try {
      const { success: i, error: s } = await e();
      if (!i)
        throw s;
      Ne(
        i,
        Ie(n, r)
      );
    } catch (i) {
      console.error(i);
    }
  } });
}, qe = d.object({
  paymentInitialize: te.optional(),
  checkoutAddressForm: X.optional(),
  beforeContent: d.custom().optional(),
  afterContent: d.custom().optional()
}), dn = w(
  "CentraCheckoutSinglePaymentMethodFlow",
  P(qe, (e) => {
    var s;
    const t = (s = e.paymentInitialize) == null ? void 0 : s.paymentMethod, n = Oe(t), r = ee(t), o = Be(), i = /* @__PURE__ */ u(Me, {});
    return /* @__PURE__ */ A(I, { children: [
      e.beforeContent && /* @__PURE__ */ u(e.beforeContent, {}),
      r && /* @__PURE__ */ u(_e, { ...e.checkoutAddressForm }),
      n && o && /* @__PURE__ */ A(I, { children: [
        /* @__PURE__ */ u(z, { component: i, children: /* @__PURE__ */ u(L, {}) }),
        /* @__PURE__ */ u(Ge, {})
      ] }),
      n && !o && /* @__PURE__ */ u(De, { ...e.paymentInitialize, children: /* @__PURE__ */ A(z, { component: i, children: [
        /* @__PURE__ */ u(L, {}),
        /* @__PURE__ */ u(we, {})
      ] }) }),
      e.afterContent && /* @__PURE__ */ u(e.afterContent, {})
    ] });
  })
), xe = d.object({
  paymentInitialize: te.optional(),
  checkoutAddressForm: X.optional(),
  beforeContent: d.custom().optional(),
  afterContent: d.custom().optional(),
  checkoutIsBlocked: d.boolean().optional()
}), hn = w(
  "CentraCheckoutSinglePageFlowWithBlocking",
  P(xe, (e) => {
    var c;
    const t = (c = e.paymentInitialize) == null ? void 0 : c.paymentMethod, n = Oe(t), r = ee(t), o = Be(), i = /* @__PURE__ */ u(Me, {}), s = e.checkoutIsBlocked ?? !1, a = n && !s;
    return /* @__PURE__ */ A(I, { children: [
      e.beforeContent && /* @__PURE__ */ u(e.beforeContent, {}),
      r && /* @__PURE__ */ u(_e, { ...e.checkoutAddressForm }),
      /* @__PURE__ */ u(L, {}),
      a && o && /* @__PURE__ */ A(I, { children: [
        /* @__PURE__ */ u(z, { component: i, children: /* @__PURE__ */ u(L, {}) }),
        /* @__PURE__ */ u(Ge, {})
      ] }),
      a && !o && /* @__PURE__ */ u(De, { ...e.paymentInitialize, children: /* @__PURE__ */ u(z, { component: i, children: /* @__PURE__ */ u(we, {}) }) }),
      e.afterContent && /* @__PURE__ */ u(e.afterContent, {})
    ] });
  })
), ze = d.object({
  selectedPaymentMethod: Se.optional(),
  singlePaymentMethodFlow: qe.optional(),
  singlePaymentMethodFlowWithBlocking: xe.optional()
}), mn = w(
  "CentraCheckoutFlow",
  P(ze, (e) => {
    const t = k(), {
      components: { CartIsEmpty: n, CheckoutLoading: r }
    } = S(), { mappers: o } = v(), i = j(), { trackOnce: s } = U({
      sessionKey: jt
    });
    return O(
      () => {
        t && s(() => {
          i.eventEmitter.emit("checkoutStarted", {
            cart: o.cart(t, [])
          });
        });
      },
      { ifDefined: [t == null ? void 0 : t.selection] }
    ), t ? t.selection.items.length === 0 ? /* @__PURE__ */ u(n, {}) : e.singlePaymentMethodFlowWithBlocking ? /* @__PURE__ */ u(
      hn,
      {
        ...e.singlePaymentMethodFlowWithBlocking
      }
    ) : /* @__PURE__ */ u(dn, { ...e.singlePaymentMethodFlow }) : /* @__PURE__ */ u(r, {});
  })
), pn = d.object({
  paymentPages: Pt,
  flow: ze.optional(),
  uiConfig: d.custom().optional(),
  checkoutEventEmitter: d.custom().optional()
}), fn = w(
  "CentraCheckout",
  P(pn, (e) => {
    const t = {
      eventEmitter: e.checkoutEventEmitter ?? it
    }, n = e.flow ?? {};
    return /* @__PURE__ */ u(st.Provider, { value: t, children: /* @__PURE__ */ u(vt, { value: e.paymentPages, children: /* @__PURE__ */ u(ke, { value: e.uiConfig, children: /* @__PURE__ */ u(
      mn,
      {
        selectedPaymentMethod: n.selectedPaymentMethod,
        singlePaymentMethodFlow: n.singlePaymentMethodFlow,
        singlePaymentMethodFlowWithBlocking: n.singlePaymentMethodFlowWithBlocking
      }
    ) }) }) });
  })
);
fn.displayName = "CentraCheckout";
const yn = ({
  error: e
}) => {
  const {
    components: { SelectionNotFound: t, PaymentMethodFailed: n }
  } = S();
  return an(e) ? /* @__PURE__ */ u(t, {}) : Fe(e) ? /* @__PURE__ */ u(n, {}) : null;
}, Cn = d.object({
  order: d.custom()
}), gn = w(
  "CentraCheckoutGenericReceipt",
  P(
    Cn,
    (e) => {
      const {
        components: { GenericOrderReceipt: t }
      } = S();
      return /* @__PURE__ */ u(t, { order: e.order });
    }
  )
), bn = d.object({
  order: d.custom(),
  paymentMethodData: d.custom()
}), Pn = w(
  "CentraCheckoutSelectedReceipt",
  P(
    bn,
    (e) => {
      var n;
      const t = (n = e.paymentMethodData) == null ? void 0 : n.snippet;
      return t ? /* @__PURE__ */ u(F, { html: t }) : /* @__PURE__ */ u(gn, { order: e.order });
    }
  )
), vn = d.object({
  postData: d.record(d.string(), d.unknown()).optional().describe(
    "Centra sends some data in the query string and some in the post body, this is the post body data"
  ),
  orderEventEmitter: d.custom().optional(),
  uiConfig: d.custom().optional()
}), Ir = w(
  "CentraCheckoutFinalize",
  P(
    vn,
    (e) => {
      const { checkoutAPIClient: t, mappers: n } = v(), [r, o] = b(null), [i, s] = b(null), [a, c] = b(null), { additionalData: l } = at(), m = async (f) => {
        (e.orderEventEmitter ?? ct).emit("orderPlaced", {
          order: f,
          additionalData: l
        });
      }, h = async (f) => {
        const C = f.items.filter((y) => !!y.bundle).map((y) => y.product.product), g = [];
        if (C.length > 0) {
          const y = await Promise.all(
            C.map(
              (E) => t.getBundle({ id: E })
            )
          );
          for (const E of y)
            E.success && g.push(E.success);
        }
        return g;
      };
      O(() => {
        async function f() {
          const g = { ...Object.fromEntries(
            new URLSearchParams(location.search.replace(/^\?/, ""))
          ), ...e.postData };
          try {
            const { success: y, error: E } = await t.paymentResult({
              paymentMethodFields: g
            });
            if (y) {
              o(y);
              const x = await h(y.order), M = n.order(y.order, x);
              s(M), m(M);
            }
            E && c(E);
          } catch (y) {
            console.error("Error finalizing Centra payment", y);
            return;
          }
        }
        f();
      });
      const p = () => r && i ? /* @__PURE__ */ u(
        Pn,
        {
          order: i,
          paymentMethodData: r.order.paymentMethodData
        }
      ) : a ? /* @__PURE__ */ u(yn, { error: a }) : null;
      return /* @__PURE__ */ u(ke, { value: e.uiConfig, children: /* @__PURE__ */ u(p, {}) });
    }
  )
), kn = d.object({}), Tr = w(
  "CentraCheckoutPaypalCommerceButtonFlow",
  P(kn, (e) => /* @__PURE__ */ u("div", { children: "CentraCheckoutPaypalCommerceButtonFlow" }))
), An = d.object({}), Mr = w(
  "CentraCheckoutStripePaymentIntentsFlow",
  P(An, (e) => /* @__PURE__ */ u("div", { children: "CentraCheckoutStripePaymentIntentsFlow" }))
), _r = ({
  paymentMethod: e
}) => {
  const [t, n] = b(null), r = V(), {
    components: { StandalonePaymentWrapper: o }
  } = S();
  return O(() => {
    const i = async () => {
      try {
        const s = await r({
          paymentMethod: e,
          paymentInitiateOnly: !0
        });
        s.success ? n(s.success) : console.error(
          `Payment initialization error for ${e}:`,
          s.error
        );
      } catch (s) {
        console.error(s);
      }
    };
    return i(), document.addEventListener(
      "centra_checkout_shipping_address_response",
      i
    ), () => {
      document.removeEventListener(
        "centra_checkout_shipping_address_response",
        i
      );
    };
  }), !t || t.action !== "form" ? null : /* @__PURE__ */ u(o, { children: /* @__PURE__ */ u(F, { html: t.formHtml }) });
}, Sn = (e) => {
  let t;
  try {
    t = JSON.parse(atob(e));
  } catch (n) {
    return console.error("error in parsing payload, invalid encoded string", n), [];
  }
  return Array.isArray(t == null ? void 0 : t.i) ? t.i.map((n) => {
    const [r, o] = n;
    if (typeof r == "string" && typeof o == "number")
      return {
        item: r,
        quantity: o
      };
  }).filter((n) => typeof n < "u") : [];
}, ce = "revive", Or = ({
  normalizeItemQuantities: e = !1,
  onCartUpdated: t,
  removeReviveFromUrl: n = !1
}) => {
  const { checkoutAPIClient: r } = v(), o = ot("fetchCart"), i = k();
  async function s(a, c, l) {
    for (const m of c)
      await r.updateItem(m);
    a.length && await r.postItems(a), await o.execute(void 0), await (t == null ? void 0 : t({
      addedItems: a,
      normalizedItems: l
    }));
  }
  return O(
    () => {
      const a = new URLSearchParams(location.search);
      let c = [];
      const l = [], m = [], h = a.get(ce), p = i == null ? void 0 : i.selection;
      if (typeof h == "string") {
        if (n) {
          a.delete(ce);
          const C = a.toString();
          window.history.replaceState(
            window.history.state,
            "",
            `${location.pathname}${C ? `?${C}` : ""}${location.hash}`
          );
        }
        const f = Sn(h);
        if (!f || !f.length)
          return;
        if (p != null && p.items.length)
          for (const C of f) {
            const g = p == null ? void 0 : p.items.find(
              (y) => y.item === C.item
            );
            if (typeof g > "u") {
              const y = {
                item: C.item,
                quantity: C.quantity
              };
              c.push(y);
            } else if (typeof (g == null ? void 0 : g.quantity) == "number" && g.quantity < C.quantity) {
              const y = {
                item: C.item,
                quantity: C.quantity - g.quantity
              };
              e ? (l.push({
                lineId: g.line,
                quantity: C.quantity
              }), m.push({
                item: C.item,
                previousQuantity: g.quantity,
                quantity: C.quantity
              })) : c.push(y);
            }
          }
        else
          c = f;
        (c.length || l.length) && s(c, l, m);
      }
    },
    { ifDefined: [r, i] }
  ), null;
}, Fr = () => {
  throw new Error("not implemented");
}, Rr = d.enum([
  "klarna_checkout",
  "qliro",
  "adyen-drop-in"
]), Dr = d.enum(["centra", "ingrid"]);
function wn(e, t) {
  switch (t.type) {
    case "SET_SELECTION_RESPONSE":
      return {
        ...e,
        selectionResponse: t.payload.selectionResponse
      };
    default:
      return e;
  }
}
function Nn(e, t, n, r) {
  var i;
  const o = (i = e.items[0]) == null ? void 0 : i.item;
  if (!o)
    throw new Error("Bundle has no item id");
  return {
    dataModel: "bundle",
    itemId: o,
    preConfiguredBundle: e.bundleInfo.type === "fixed",
    base: r.centraCheckoutApiProductToGreaseProductBase(
      e,
      n,
      r
    ),
    bundlePurchaseInfo: r.centraCheckoutApiBundleToGreaseBundlePurchaseInfo(
      e,
      n
    ),
    sections: r.centraCheckoutApiBundleToGreaseBundleSections(
      e,
      t,
      n,
      r
    ),
    siblingProducts: []
  };
}
function En(e, { context: { currencyCode: t } }) {
  var o;
  const n = (o = e.items[0]) == null ? void 0 : o.stock, r = typeof n == "number" ? n : n === "yes" ? 1 : 0;
  return {
    sku: e.sku,
    inventory: {
      inStock: r > 0,
      warehouseId: "not-supported-yet",
      quantity: r
    },
    priceInfo: {
      price: {
        formatted: e.price,
        number: e.priceAsNumber
      },
      priceWithoutDiscount: {
        formatted: e.priceBeforeDiscount,
        number: e.priceBeforeDiscountAsNumber
      },
      previouslyDiscountedPrices: []
      // TODO: Implement previously discounted prices
    },
    additionalInventory: [],
    priceOfItemsOutsideBundle: {
      formatted: e.bundleInfo.priceOfItems,
      number: e.bundleInfo.priceOfItemsAsNumber
    },
    discountFromPriceOfItemsOutsideBundle: {
      formatted: Math.round(
        e.bundleInfo.priceOfItemsAsNumber - e.bundleInfo.priceMinAsNumber
      ) + " " + t,
      number: Math.round(
        e.bundleInfo.priceOfItemsAsNumber - e.bundleInfo.priceMinAsNumber
      )
    },
    priceMax: {
      formatted: e.bundleInfo.priceMax,
      number: e.bundleInfo.priceMaxAsNumber
    },
    priceMin: {
      formatted: e.bundleInfo.priceMin,
      number: e.bundleInfo.priceMinAsNumber
    }
  };
}
function In(e, t, n, r) {
  return e.bundleInfo.sections.map((o) => ({
    sectionId: o.section,
    quantity: o.quantity,
    products: o.products.map((i) => {
      const s = t.find(
        (a) => a.product === i.toString()
      );
      if (s)
        return r.centraCheckoutApiProductToGreaseProduct(
          s,
          n,
          r
        );
    }).filter(q)
  }));
}
function Tn(e, t, n, r) {
  return {
    dimensions: r.centraCheckoutApiProductItemToGreaseProductVariantDimensions(
      t,
      e,
      n
    ),
    label: t.name,
    mainProductId: e.product,
    mainProductKey: e.product,
    variantId: t.item,
    variantKey: t.item,
    outOfStockItemId: t.item,
    ...r.centraCheckoutApiItemToGreasePurchaseInfo(e, t)
  };
}
function Mn(e, t) {
  var i;
  const n = e.priceAsNumber !== e.priceBeforeDiscountAsNumber, r = Math.round(
    (1 - e.priceAsNumber / e.priceBeforeDiscountAsNumber) * 100
  ), o = typeof t.stock == "number" ? t.stock : t.stock === "yes" ? 1 : 0;
  return {
    sku: t.sku,
    inventory: {
      quantity: o,
      inStock: o > 0,
      warehouseId: "1"
    },
    additionalInventory: [],
    priceInfo: {
      price: { formatted: e.price, number: e.priceAsNumber },
      priceWithoutDiscount: {
        formatted: e.priceBeforeDiscount,
        number: e.priceBeforeDiscountAsNumber
      },
      previouslyDiscountedPrices: (i = e.lowestPrice) == null ? void 0 : i.map((s) => ({
        date: new Date(Date.now() - s.periodDays * 24 * 60 * 60 * 1e3),
        periodDays: s.periodDays,
        price: { formatted: s.price, number: s.priceAsNumber },
        priceWithoutDiscount: {
          formatted: s.priceBeforeDiscount,
          number: s.priceBeforeDiscountAsNumber
        }
      })),
      discountInfo: n ? {
        percent: r
      } : void 0
    }
  };
}
const _n = (e, t, n, r) => {
  var o, i;
  return {
    orderNumber: e.order,
    currencyCode: e.currencyFormat.currency,
    status: r.centraCheckoutApiOrderStatusToGreaseOrderStatus(
      e.status
    ),
    date: new Date(e.date),
    additionalNotes: e.additionalNotes,
    paymentMethod: e.paymentMethodName,
    shippingMethod: e.shippingMethodName,
    itemQuantity: e.items.reduce((s, a) => s + a.quantity, 0) ?? 0,
    items: e.items.map(
      (s) => r.centraSelectionItemToGreaseLineItem(
        s,
        t,
        n,
        e.currencyFormat,
        r
      )
    ),
    totals: r.centraCheckoutApiOrderTotalsToGreaseOrderTotals(
      e.totals,
      e.items,
      e.currencyFormat
    ),
    billingAddress: r.centraCheckoutApiOrderAddressToGreaseOrderAddress(
      e.address
    ),
    shippingAddress: r.centraCheckoutApiOrderAddressToGreaseOrderAddress(
      e.shippingAddress
    ),
    vouchers: ((i = (o = e.discounts) == null ? void 0 : o.vouchers) == null ? void 0 : i.map(
      (s) => r.centraCheckoutApiVoucherToGreaseCodeVoucher(s)
    )) ?? []
  };
}, On = (e) => e ? {
  firstName: e.firstName ?? "",
  lastName: e.lastName ?? "",
  email: e.email ?? "",
  street: e.address1 ?? "",
  zipCode: e.zipCode ?? "",
  city: e.city ?? "",
  country: e.country ?? "",
  state: e.state ?? "",
  phoneNumber: e.phoneNumber ?? ""
} : {
  firstName: "",
  lastName: "",
  email: "",
  street: "",
  zipCode: "",
  city: "",
  country: "",
  state: "",
  phoneNumber: ""
};
function Fn(e) {
  switch (e) {
    case "untouched":
      return "pending";
    case "progress":
      return "processing";
    case "ok":
      return "completed";
    case "archived":
    case "failed":
      return "cancelled";
  }
  throw new Error(`Unknown order status: ${e}`);
}
const Rn = (e, t, n) => {
  if (n.productOptions.itemDimensionParser)
    return n.productOptions.itemDimensionParser(e);
  const r = e.name.split(t.itemTable.dividerSymbol), o = (a, c) => r.length === 1 ? "size" : a.replace(/[^\d\w]+/g, "_") + "_" + c, i = (a) => r.length === 1 ? e.item : a, s = (a) => r.length === 1 ? e.name : a;
  return r.map((a, c) => ({
    value: i(a),
    valueLabel: s(a),
    dimensionKey: o(t.itemTable.desc, c),
    dimensionLabel: o(t.itemTable.desc, c)
  }));
}, Dn = (e, t, n, r) => {
  if (e.bundleInfo) {
    const o = t.find(
      (i) => i.bundle.product === e.product
    );
    return o ? r.centraCheckoutApiBundleToGreaseBundle(
      o.bundle,
      o.sectionProducts,
      n,
      r
    ) : (console.error(
      `Bundle "${e.product}" has no bundle info, cannot create product`
    ), r.centraCheckoutApiProductToGreaseProduct(
      e,
      n,
      r
    ));
  }
  return r.centraCheckoutApiProductToGreaseProduct(
    e,
    n,
    r
  );
};
function Bn(e, t, n) {
  return e.items.length === 1 ? n.centraCheckoutApiProductToGreaseProductSimple(
    e,
    t,
    n
  ) : n.centraCheckoutApiProductToGreaseProductWithVariants(
    e,
    t,
    n
  );
}
function Gn(e, t) {
  return [];
}
function qn(e, t, n) {
  var o;
  let r = e.uri;
  if (t.productOptions.uriField) {
    const i = e[t.productOptions.uriField];
    typeof i == "string" && i.length > 0 && (r = i);
  }
  return {
    productId: e.product,
    productKey: e.sku,
    slug: r,
    discontinued: !1,
    content: n.centraCheckoutApiProductToGreaseProductContent(
      e,
      t,
      n
    ),
    attributes: n.centraCheckoutApiProductToGreaseProductExtraAttributes(e),
    categories: ((o = e.categories) == null ? void 0 : o.map((i) => ({
      categoryId: i.category,
      categoryKey: i.category,
      name: i.name.join(" / "),
      slug: i.uri
    }))) ?? []
  };
}
function xn(e, t, n) {
  return {
    name: e.name,
    description: e.description,
    shortDescription: e.excerpt,
    media: n.centraCheckoutApiProductToGreaseProductMedia(
      e,
      t
    ),
    badges: n.centraCheckoutApiProductToGreaseProductBadges(
      e,
      t
    ),
    // Centra also has uri and ID for this, maybe we should support that?
    brand: e.brandName ?? void 0
  };
}
function zn(e) {
  const t = {
    attributeKey: "product_color",
    attributeLabel: "Order_Summary_Color_Label",
    value: e.variantName,
    valueLabel: e.variantName
  }, n = {
    attributeKey: "tableMappings",
    attributeLabel: "tableMappings",
    value: e.tableMappings ?? {},
    valueLabel: "tableMappings"
  };
  return [...Object.keys(e).filter((o) => !$e.shape.hasOwnProperty(o)).filter(
    (o) => !Qe.shape.hasOwnProperty(o)
  ).reduce((o, i) => [
    ...o,
    {
      attributeKey: i,
      attributeLabel: i,
      value: e[i],
      valueLabel: `${e[i]}`
      // Centra doesn't support value labels for attributes
    }
  ], []).filter((o) => o.value !== void 0), t, n];
}
function Ln(e, t) {
  var r;
  const n = (r = e.media) == null ? void 0 : r[t.productOptions.productImageKey];
  return n ? n.map((o, i) => {
    var s, a, c, l;
    return {
      type: "image",
      src: o,
      alt: ((a = (s = e.mediaObjects) == null ? void 0 : s[i]) == null ? void 0 : a.altText) || e.name,
      attributes: Object.entries(((l = (c = e.mediaObjects) == null ? void 0 : c[i]) == null ? void 0 : l.attributes) ?? {}).map(
        ([m, h]) => ({
          attributeKey: m,
          attributeLabel: m,
          value: h,
          valueLabel: `${h}`
        })
      ) || []
    };
  }) : e.mediaUrls ? e.mediaUrls.map((o, i) => {
    var s, a, c, l;
    return {
      type: "image",
      src: o,
      alt: ((a = (s = e.mediaObjects) == null ? void 0 : s[i]) == null ? void 0 : a.altText) || e.name,
      attributes: Object.entries(((l = (c = e.mediaObjects) == null ? void 0 : c[i]) == null ? void 0 : l.attributes) ?? {}).map(
        ([m, h]) => ({
          attributeKey: m,
          attributeLabel: m,
          value: h,
          valueLabel: `${h}`
        })
      ) || []
    };
  }) : (console.warn(
    `No media found for product ${e.product}. This is likely a misconfiguration.`
  ), []);
}
const jn = (e, t, n) => {
  var r;
  return ((r = e.relatedProducts) == null ? void 0 : r.map((o) => {
    if (o.relation === "variant")
      return n.centraCheckoutApiProductToGreaseProductBase(
        o,
        t,
        n
      );
  }).filter(q)) ?? [];
};
function Wn(e, t, n, r) {
  const { selection: o, token: i } = e, s = o.discounts.vouchers.map(
    (a) => r.centraCheckoutApiVoucherToGreaseCodeVoucher(a)
  ).concat(
    o.discounts.automaticDiscounts.map(
      (a) => r.centraCheckoutApiAutoVoucherToGreaseAutoVoucher(a)
    )
  ) ?? [];
  return {
    cartId: i,
    currencyCode: o.currency,
    languageCode: o.language,
    vouchers: s,
    paymentMethod: {
      code: o.paymentMethod,
      name: o.paymentMethodName
    },
    shippingMethod: {
      code: o.shippingMethod,
      name: o.shippingMethodName
    },
    items: o.items.map(
      (a) => r.centraSelectionItemToGreaseLineItem(
        a,
        t,
        n,
        o.currencyFormat,
        r
      )
    ),
    totals: r.centraSelectionToGreaseCartTotals(
      o.totals,
      o.items,
      // required to calculate subtotal
      o.currencyFormat
    )
  };
}
const Un = (e) => ({
  id: e.customer,
  firstName: e.firstName,
  lastName: e.lastName,
  email: e.email,
  addresses: [
    {
      firstName: e.firstName,
      lastName: e.lastName,
      street: e.address1,
      street2: e.address2,
      city: e.city,
      state: e.state,
      zipCode: e.zipCode,
      country: e.country,
      phoneNumber: e.phoneNumber
    }
  ],
  attributes: {}
});
function Vn(e, t) {
  return t > 0 ? Math.trunc(e) : Math.round(e);
}
function G(e, t) {
  if (!t)
    return "";
  const n = parseInt(t.decimalDigits ?? "0"), r = e % 1, o = Vn(e, n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, t.thousandsSeparator ?? " "), i = n > 0 ? `${t.decimalPoint}${String(
    Math.round(r * Math.pow(10, n))
  ).padStart(n, "0")}` : "";
  return `${t.prefix}${o}${i}${t.suffix}`;
}
function Hn(e, t, n, r, o) {
  var p;
  let i, s;
  const a = parseInt(r.decimalDigits ?? "0"), c = Math.pow(10, a), l = Math.round(
    c * (e.totalPriceAfterDiscountAsNumber / e.quantity)
  ) / c;
  l === 0 ? (s = {
    number: e.totalPriceAsNumber,
    formatted: e.totalPrice
  }, i = {
    number: e.priceEachAsNumber,
    formatted: e.priceEach
  }) : (s = {
    number: e.totalPriceAfterDiscountAsNumber,
    formatted: e.totalPriceAfterDiscount
  }, i = {
    number: l,
    formatted: G(l, r)
  });
  const m = {
    lineId: e.line,
    id: e.item,
    quantity: e.quantity,
    sku: e.sku,
    price: {
      discounted: typeof e.priceEachBeforeDiscountAsNumber == "number",
      priceEach: i,
      priceEachWithoutDiscount: {
        number: e.priceEachBeforeDiscountAsNumber,
        formatted: e.priceEachBeforeDiscount
      },
      priceEachWithoutTax: {
        number: e.priceEachWithoutTaxAsNumber,
        formatted: e.priceEachWithoutTax
      },
      totalPrice: s
    }
  }, h = (f) => {
    if (!Array.isArray(f))
      return;
    const C = t.find(
      (y) => y.bundle.product === e.product.product
    );
    if (!C) {
      console.warn(
        `Bundle "${e.product.product}" has no bundle info, cannot create product, cart item will be a product instead`
      );
      return;
    }
    const g = o.centraCheckoutApiBundleToGreaseBundle(
      C.bundle,
      C.sectionProducts,
      n,
      o
    );
    return {
      type: "bundle",
      bundleItems: f.map((y) => {
        const E = g.sections.flatMap((M) => M.products).find((M) => M.base.productId === y.product);
        let x;
        return E && (x = E.base.content.media.find(
          (M) => M.type === "image"
        )), {
          id: y.product,
          name: y.productName,
          quantity: y.quantity,
          image: x,
          price: {
            discounted: y.priceEachBeforeDiscountAsNumber > y.priceEachAsNumber,
            priceEach: {
              number: y.priceEachAsNumber,
              formatted: y.priceEach
            },
            priceEachWithoutDiscount: {
              number: y.priceEachBeforeDiscountAsNumber,
              formatted: y.priceEachBeforeDiscount
            },
            priceEachWithoutTax: {
              number: y.priceEachWithoutTaxAsNumber,
              formatted: y.priceEachWithoutTax
            },
            totalPrice: {
              number: y.totalPriceAsNumber,
              formatted: y.totalPrice
            }
          },
          itemDimensions: [
            {
              value: y.size,
              valueLabel: y.size,
              dimensionKey: "size",
              dimensionLabel: "size"
            }
          ]
        };
      }),
      ...m,
      product: g
    };
  };
  if (Array.isArray(e.bundle) && ((p = e.product.bundleInfo) == null ? void 0 : p.type) === "flexible") {
    const f = h(e.bundle);
    if (f)
      return f;
  }
  return {
    type: "product",
    ...m,
    itemDimensions: [
      {
        value: e.size,
        valueLabel: e.size,
        dimensionKey: "size",
        dimensionLabel: "size"
      }
    ],
    product: o.centraCheckoutApiProductToGreaseProduct(
      e.product,
      n,
      o
    )
  };
}
function Kn(e, t, n) {
  let r;
  typeof e.taxAddedAsNumber == "number" && typeof e.taxAdded == "string" ? r = {
    number: e.taxAddedAsNumber,
    formatted: e.taxAdded
  } : r = {
    number: e.grandTotalPriceTaxAsNumber,
    formatted: e.grandTotalPriceTax
  };
  const o = t.reduce((a, c) => {
    const m = c.totalPriceAfterDiscountAsNumber === 0 ? 0 : c.priceEachAsNumber * c.quantity;
    return a + m;
  }, 0), i = t.reduce(
    (a, c) => a + c.priceEachWithoutTaxAsNumber * c.quantity,
    0
  );
  let s;
  return typeof e.totalDiscountPriceAsNumber == "number" && typeof e.totalDiscountPrice == "string" && (s = {
    number: e.totalDiscountPriceAsNumber,
    formatted: e.totalDiscountPrice
  }), {
    grandTotal: {
      number: e.grandTotalPriceAsNumber,
      formatted: e.grandTotalPrice
    },
    shipping: {
      number: e.shippingPriceAsNumber,
      formatted: e.shippingPrice
    },
    subtotalWithoutTax: {
      number: i,
      formatted: G(
        i,
        n
      )
    },
    subtotal: {
      number: o,
      formatted: G(o, n)
    },
    discount: s,
    tax: r
  };
}
function $n(e, t, n) {
  const r = e.items[0], o = n.centraCheckoutApiProductToGreaseProductBase(
    e,
    t,
    n
  ), i = n.centraCheckoutApiRelatedProductsToSiblingProducts(
    e,
    t,
    n
  );
  return {
    dataModel: "simple",
    isBundle: e.bundleInfo !== void 0,
    base: o,
    siblingProducts: i,
    itemId: r.item,
    outOfStockItemId: r.item,
    ...n.centraCheckoutApiItemToGreasePurchaseInfo(e, r)
  };
}
function Qn(e, t, n) {
  const r = n.centraCheckoutApiProductToGreaseProductBase(
    e,
    t,
    n
  ), o = n.centraCheckoutApiRelatedProductsToSiblingProducts(
    e,
    t,
    n
  );
  return {
    dataModel: "with_variants",
    base: r,
    siblingProducts: o,
    variants: e.items.map(
      (i) => n.centraCheckoutApiItemToGreaseProductVariant(
        e,
        i,
        t,
        n
      )
    ).filter((i) => !!i)
  };
}
const Yn = (e) => ({
  type: "auto",
  name: e.name,
  affectsOrderTotal: e.hasAffectedOrder,
  discount: {
    number: e.priceOffAsNumber,
    formatted: e.priceOff
  }
}), Jn = (e) => ({
  type: "code",
  code: e.voucher,
  name: e.description,
  affectsOrderTotal: e.hasAffectedOrder,
  discount: {
    number: e.priceOffAsNumber,
    formatted: e.priceOff
  }
});
function Zn(e, t, n) {
  const r = t.reduce(
    (s, a) => s + a.priceEachWithoutTaxAsNumber * a.quantity,
    0
  ), o = t.reduce((s, a) => {
    const l = a.totalPriceAfterDiscountAsNumber === 0 ? 0 : a.priceEachAsNumber * a.quantity;
    return s + l;
  }, 0);
  let i;
  return typeof e.totalOriginalDiscountPriceAsNumber == "number" && typeof e.totalOriginalDiscountPrice == "string" && (i = {
    number: e.totalOriginalDiscountPriceAsNumber,
    formatted: e.totalOriginalDiscountPrice
  }), {
    grandTotal: {
      number: e.grandTotalPriceAsNumber,
      formatted: e.grandTotalPrice
    },
    shipping: {
      number: e.shippingPriceAsNumber,
      formatted: e.shippingPrice
    },
    subtotalWithoutTax: {
      number: r,
      formatted: G(
        r,
        n
      )
    },
    subtotal: {
      number: o,
      formatted: G(o, n)
    },
    discount: i,
    tax: {
      number: e.grandTotalPriceTaxAsNumber,
      formatted: e.grandTotalPriceTax
    }
  };
}
const ne = {
  centraCheckoutApiBundleToGreaseBundlePurchaseInfo: En,
  centraCheckoutApiBundleToGreaseBundleSections: In,
  centraCheckoutApiBundleToGreaseBundle: Nn,
  centraCheckoutApiItemToGreaseProductVariant: Tn,
  centraCheckoutApiItemToGreasePurchaseInfo: Mn,
  centraCheckoutApiOrderAddressToGreaseOrderAddress: On,
  centraCheckoutApiOrderStatusToGreaseOrderStatus: Fn,
  centraCheckoutApiOrderToGreaseOrder: _n,
  centraCheckoutApiProductToGreaseItemProduct: Dn,
  centraCheckoutApiProductToGreaseProductBase: qn,
  centraCheckoutApiProductToGreaseProductContent: xn,
  centraCheckoutApiProductToGreaseProductMedia: Ln,
  centraCheckoutApiProductToGreaseProduct: Bn,
  centraCheckoutApiRelatedProductsToSiblingProducts: jn,
  centraCheckoutApiSelectionToGreaseCart: Wn,
  centraCheckoutApiCustomerToGreaseCustomer: Un,
  centraSelectionItemToGreaseLineItem: Hn,
  centraSelectionToGreaseCartTotals: Kn,
  centraCheckoutApiOrderTotalsToGreaseOrderTotals: Zn,
  centraCheckoutApiProductToGreaseProductExtraAttributes: zn,
  centraCheckoutApiProductItemToGreaseProductVariantDimensions: Rn,
  centraCheckoutApiProductToGreaseProductBadges: Gn,
  centraCheckoutApiProductToGreaseProductWithVariants: Qn,
  centraCheckoutApiProductToGreaseProductSimple: $n,
  centraCheckoutApiAutoVoucherToGreaseAutoVoucher: Yn,
  centraCheckoutApiVoucherToGreaseCodeVoucher: Jn
};
function Xn(e, t = {}) {
  const n = { ...ne, ...t };
  return function(o, i = []) {
    var s;
    if (((s = o.bundleInfo) == null ? void 0 : s.type) === "flexible" && i.length) {
      const a = i.find(
        (c) => c.bundle.product === o.product
      );
      if (a)
        return n.centraCheckoutApiBundleToGreaseBundle(
          a.bundle,
          a.sectionProducts,
          e,
          n
        );
      console.error(`Bundle "${o.product}" missing; falling back.`);
    }
    return n.centraCheckoutApiProductToGreaseProduct(
      o,
      e,
      n
    );
  };
}
function er(e, t = {}) {
  const n = { ...ne, ...t };
  return function(o, i = []) {
    return n.centraCheckoutApiOrderToGreaseOrder(
      o,
      i,
      e,
      n
    );
  };
}
function tr(e, t = {}) {
  const n = { ...ne, ...t };
  return function(o, i = []) {
    return n.centraCheckoutApiSelectionToGreaseCart(
      o,
      i,
      e,
      n
    );
  };
}
const nr = (e) => {
  var c, l, m;
  const [t, n] = nt(wn, {}), r = Xn(
    (c = e.mapperOptions) == null ? void 0 : c.options,
    e.mapperOptions.mappers
  ), o = tr(
    (l = e.mapperOptions) == null ? void 0 : l.options,
    e.mapperOptions.mappers
  ), i = er(
    (m = e.mapperOptions) == null ? void 0 : m.options,
    e.mapperOptions.mappers
  ), s = {
    checkoutAPIClient: e.checkoutAPIClient,
    queryContext: e.queryContext,
    mappers: {
      product: r,
      cart: o,
      order: i
    }
  }, a = R(!1);
  return N(() => {
    async function h() {
      if (!a.current)
        return a.current = !0, Re(e.checkoutAPIClient, n);
    }
    const p = e.initializationType || "onLoad";
    p === "onLoad" && h(), p === "onInteraction" && console.error("CentraProvider: 'onInteraction' not implemented yet");
  }, [e.initializationType]), /* @__PURE__ */ u(he.Provider, { value: s, children: /* @__PURE__ */ u(pe.Provider, { value: t, children: /* @__PURE__ */ u(fe.Provider, { value: n, children: /* @__PURE__ */ u(Ce, { children: e.children }) }) }) });
};
nr.displayName = "CentraProvider";
class Br {
  constructor(t, n) {
    this.client = t, this.defaultOptions = n;
  }
  createOptions(t = {}) {
    const n = Ye.safeParse({
      ...this.defaultOptions,
      ...t
    });
    if (!n.success)
      throw new Error(
        `[CentraNewsletterClient]: Invalid input data for Centra newsletter, ${JSON.stringify(
          n.error.errors
        )}`
      );
    return n.data;
  }
  async subscribe(t) {
    await this.client.subscribeToNewsletter(
      t.email,
      this.createOptions(t.attributes)
    );
  }
  async unsubscribe(t) {
    throw new Error(
      "[CentraNewsletterClient]: Unsubscribe method not implemented"
    );
  }
}
const Le = _(void 0), rr = (e) => {
  const t = B(
    () => ({
      searchFunctionGetter: e.searchFunctionGetter
    }),
    [e.searchFunctionGetter]
  );
  return /* @__PURE__ */ u(Le.Provider, { value: t, children: e.children });
};
rr.displayName = "CentraSearchProvider";
const or = (e, t, n, r) => (e === "items.name" && (r != null && r.length) && t.sort((o, i) => {
  if (typeof o.data != "string" || typeof i.data != "string")
    return 0;
  const s = r.indexOf(o.data), a = r.indexOf(i.data);
  return s === -1 && a === -1 ? 0 : s === -1 ? 1 : a === -1 ? -1 : s - a;
}), t.map(({ data: o, count: i = 0 }) => {
  let s, a, c;
  if (typeof o == "string")
    a = s = o;
  else if (typeof o == "object" && o !== null) {
    if (e === "swatch.desc" && typeof o.desc == "string" && typeof o.hex == "string")
      s = o.desc, c = o.hex, a = o.desc;
    else if (e === "brands") {
      if (!(o != null && o.brand))
        return;
      a = o.brand;
    } else if (e === "categories") {
      if (!(o != null && o.category))
        return;
      a = o.category;
    }
    typeof o.name == "string" ? s = o.name : Array.isArray(o.name) && (s = o.name.join(" / "));
  } else {
    console.error("Unknown Centra filter data type", o);
    return;
  }
  if (!a || !s)
    return;
  const l = n.includes(a), m = !(l || i > 0);
  return { name: s, selected: l, disabled: m, count: i, id: a, hex: c };
}).filter(q));
function ir(e) {
  return Object.keys(e).filter(
    (t) => t !== "limit" && t !== "skipFirst" && t !== "sortOrder"
  ).filter((t) => {
    const n = e[t];
    return de(n) && n.length > 0;
  });
}
const sr = (e, t, n, r) => {
  if (!e)
    return [];
  const o = ir(n);
  return e.filter(({ values: i }) => i && i.length > 0).map(({ field: i, values: s }) => {
    if (!i || !s || o.includes(i))
      return;
    const a = de(t[i]) ? t[i] : [], c = s.filter(
      (l) => l.filterCount && l.filterCount > 0
    );
    if (!(c.length <= 1))
      return {
        name: i,
        id: i,
        type: "checkbox",
        selectedCount: a.length,
        values: or(
          i,
          c,
          a,
          r
        )
      };
  }).filter(q);
}, re = (e) => {
  const { checkoutAPIClient: t } = v(), n = T(Le), r = H(), { mappers: o } = v();
  return n != null && n.searchFunctionGetter ? n.searchFunctionGetter(e) : async (i) => {
    const s = {
      limit: r.defaultItemsPerPage,
      // Set default limit if not provided in payload
      ...i
    }, { success: a } = await t.getProducts(s);
    if (!a || !a.products)
      return ue;
    const c = a.productCount ?? 0, m = (s.skipFirst ?? 0) / s.limit + 1, h = {
      itemsPerPage: s.limit,
      totalItems: c,
      totalPages: Math.ceil(c / s.limit),
      currentPage: m
    }, p = a.products.map((C) => ({
      type: "product",
      product: o.product(C)
    })).filter(q), f = sr(
      a.filter,
      s,
      e
    );
    return {
      items: p,
      meta: h,
      facets: f,
      sort: []
      // Not yet supported
    };
  };
}, je = (e, t) => {
  let n = e;
  return t.forEach((r) => {
    if (r.type !== "checkbox")
      return;
    const o = r.values.filter((i) => i.selected);
    n = {
      ...n,
      [r.id]: o.map((i) => i.id)
    };
  }), n;
}, ar = (e) => {
  const t = re(e), n = H();
  return async (r, o) => {
    if (!o)
      return [];
    let i = {
      ...e,
      skipFirst: (r - 1) * (e.limit ?? n.defaultItemsPerPage)
    };
    return i = je(
      i,
      o.facets
    ), (await t(i)).items;
  };
}, cr = (e) => {
  const t = re(e);
  return async (n) => {
    let r = {
      ...e,
      skipFirst: 0
      // Always reset pagination when changing facets
    };
    return r = je(
      r,
      n
    ), await t(r);
  };
}, ur = d.object({
  payload: Je.extend({
    limit: d.union([d.number().int().default(20), d.string().default("20")]).optional()
  }),
  children: d.custom()
}), Gr = w(
  "CentraSearchResultsProvider",
  P(
    ur,
    (e) => {
      const t = H(), n = Xe(), { queryContext: r } = v(), o = e.payload.limit ? Number(e.payload.limit) : t.defaultItemsPerPage, i = {
        ...e.payload,
        skipFirst: (n - 1) * o,
        limit: o
      }, s = re(i), a = ar(i), c = cr(i), l = B(
        () => ({
          initialPayload: i,
          queryContext: r
        }),
        [i, r]
      ), m = B(
        () => ({
          fetchSearchResult: async () => await s(i),
          loadPage: a,
          setFacets: c,
          setSortOrder: async () => Promise.resolve(ue)
        }),
        [s, i, a, c]
      );
      return /* @__PURE__ */ u(
        et,
        {
          queryParams: l,
          searchMethods: m,
          children: e.children
        }
      );
    }
  )
);
export {
  Wt as ADD_PAYMENT_INFO_SESSION_KEY,
  Z as ADD_SHIPPING_INFO_SESSION_KEY,
  It as AddressForm,
  ie as CENTRA_CHECKOUT_SHIPPING_ADDRESS_CALLBACK_EVENT_NAME,
  se as CENTRA_CHECKOUT_SHIPPING_METHOD_CALLBACK_EVENT_NAME,
  jt as CHECKOUT_STARTED_SESSION_KEY,
  Ar as CentraAccountClient,
  Ct as CentraAutoCompleteClient,
  Sr as CentraAutoCompleteProvider,
  wr as CentraBackInStockClient,
  gt as CentraCartClientDriver,
  fn as CentraCheckout,
  Er as CentraCheckoutError,
  Ir as CentraCheckoutFinalize,
  yn as CentraCheckoutFinalizeError,
  mn as CentraCheckoutFlow,
  Ge as CentraCheckoutFreeOrder,
  gn as CentraCheckoutGenericReceipt,
  F as CentraCheckoutHtml,
  Lt as CentraCheckoutPaymentAdyenDropIn,
  qt as CentraCheckoutPaymentKlarnaCheckout,
  zt as CentraCheckoutPaymentQliro,
  Tr as CentraCheckoutPaypalCommerceButtonFlow,
  vt as CentraCheckoutProvider,
  Me as CentraCheckoutScript,
  we as CentraCheckoutSelectedPaymentMethod,
  Pn as CentraCheckoutSelectedReceipt,
  L as CentraCheckoutSelectedShippingMethod,
  Kt as CentraCheckoutShippingCentra,
  Vt as CentraCheckoutShippingCentraOption,
  Qt as CentraCheckoutShippingIngrid,
  dn as CentraCheckoutSinglePageFlow,
  hn as CentraCheckoutSinglePageFlowWithBlocking,
  Mr as CentraCheckoutStripePaymentIntentsFlow,
  ke as CentraCheckoutUiConfigProvider,
  Ce as CentraGreaseCartProvider,
  Br as CentraNewsletterClient,
  De as CentraPaymentInitialize,
  nr as CentraProvider,
  Or as CentraReviveCart,
  rr as CentraSearchProvider,
  Gr as CentraSearchResultsProvider,
  _r as CentraStandalonePaymentButton,
  _e as CheckoutAddressForm,
  Ot as GenericOrderReceipt,
  un as PaymentInitializeError,
  _t as PaymentMethodFailed,
  D as PaymentWrapper,
  z as RenderAfterChildren,
  Ft as SelectionNotFound,
  Nt as ShippingMethodOption,
  Tt as ShippingMethods,
  wt as ShippingMethodsNotConfigured,
  Rt as UnsupportedPaymentMethodFlow,
  Mt as YourCartHasBeenModified,
  Yn as centraCheckoutApiAutoVoucherToGreaseAutoVoucher,
  Nn as centraCheckoutApiBundleToGreaseBundle,
  En as centraCheckoutApiBundleToGreaseBundlePurchaseInfo,
  In as centraCheckoutApiBundleToGreaseBundleSections,
  Un as centraCheckoutApiCustomerToGreaseCustomer,
  Tn as centraCheckoutApiItemToGreaseProductVariant,
  Mn as centraCheckoutApiItemToGreasePurchaseInfo,
  On as centraCheckoutApiOrderAddressToGreaseOrderAddress,
  Fn as centraCheckoutApiOrderStatusToGreaseOrderStatus,
  _n as centraCheckoutApiOrderToGreaseOrder,
  Zn as centraCheckoutApiOrderTotalsToGreaseOrderTotals,
  Rn as centraCheckoutApiProductItemToGreaseProductVariantDimensions,
  Dn as centraCheckoutApiProductToGreaseItemProduct,
  Bn as centraCheckoutApiProductToGreaseProduct,
  Gn as centraCheckoutApiProductToGreaseProductBadges,
  qn as centraCheckoutApiProductToGreaseProductBase,
  xn as centraCheckoutApiProductToGreaseProductContent,
  zn as centraCheckoutApiProductToGreaseProductExtraAttributes,
  Ln as centraCheckoutApiProductToGreaseProductMedia,
  $n as centraCheckoutApiProductToGreaseProductSimple,
  Qn as centraCheckoutApiProductToGreaseProductWithVariants,
  jn as centraCheckoutApiRelatedProductsToSiblingProducts,
  Hn as centraCheckoutApiSelectionItemToGreaseLineItem,
  Wn as centraCheckoutApiSelectionToGreaseCart,
  Kn as centraCheckoutApiSelectionToGreaseCartTotals,
  Jn as centraCheckoutApiVoucherToGreaseCodeVoucher,
  Xt as centraCheckoutCallback,
  K as centraCheckoutContext,
  Pt as centraCheckoutContextSchema,
  kt as centraCheckoutErrorSchema,
  vn as centraCheckoutFinalizeSchema,
  ze as centraCheckoutFlowSchema,
  Cn as centraCheckoutGenericReceiptSchema,
  Zt as centraCheckoutPaymentCallback,
  Gt as centraCheckoutPaymentKlarnaCheckoutSchema,
  xt as centraCheckoutPaymentQliroSchema,
  kn as centraCheckoutPaypalCommerceButtonFlowSchema,
  pn as centraCheckoutSchema,
  Se as centraCheckoutSelectedPaymentMethodSchema,
  bn as centraCheckoutSelectedReceiptSchema,
  Jt as centraCheckoutSelectedShippingMethodSchema,
  Ut as centraCheckoutShippingCentraOptionSchema,
  Ht as centraCheckoutShippingCentraSchema,
  $t as centraCheckoutShippingIngridSchema,
  xe as centraCheckoutSinglePageFlowWithBlockingSchema,
  qe as centraCheckoutSinglePaymentMethodFlowSchema,
  An as centraCheckoutStripePaymentIntentsFlowSchema,
  ve as centraCheckoutUiConfigContext,
  he as centraContext,
  Re as centraFetchSelection,
  sr as centraFiltersToGreaseFacets,
  te as centraPaymentInitializeSchema,
  Rr as centraPaymentMethodType,
  wn as centraReducer,
  fe as centraReducerDispatch,
  pe as centraReducerState,
  Le as centraSearchContext,
  ur as centraSearchResultsProviderSchema,
  Dr as centraShippingMethodType,
  X as checkoutAddressFormSchema,
  tn as createCentraCheckoutShippingAddressCallback,
  nn as createCentraCheckoutShippingMethodCallback,
  ne as defaultCentraCheckoutApiMappers,
  me as fetchBundlesByIds,
  ft as fetchCustomer,
  dt as fetchOrders,
  G as formatCentraPrice,
  Sn as getCartPayloadFromUrlPart,
  Ie as getPaymentPage,
  Ne as handlePostPaymentAction,
  an as isCentraFinalizeSelectionNotFoundError,
  Fe as isCentraPaymentFailedError,
  cn as isCentraPaymentUnavailableItemsError,
  Y as isFormResponse,
  ut as login,
  pt as logout,
  er as makeCentraCheckoutApiOrderToGreaseOrderMapper,
  Xn as makeCentraCheckoutApiProductToGreaseProductMapper,
  tr as makeCentraCheckoutApiSelectionToGreaseCartMapper,
  ae as mapCentraAddressFieldToGreaseCheckoutFields,
  or as mapFacetValues,
  Pe as paymentInitializeContext,
  lt as register,
  ge as replaceScriptNode,
  ht as resetPassword,
  je as searchResultFacetsToCentraGetProductsPayload,
  Te as sendCentraShippingUpdateEvent,
  mt as sendResetPasswordEmail,
  sn as updateCentraAddressFields,
  yt as updateCustomer,
  en as useAdditionalPaymentFields,
  Oe as useCentraAddressIsValid,
  Nr as useCentraBundleResponse,
  $ as useCentraCheckout,
  S as useCentraCheckoutUiConfig,
  ee as useCentraCheckoutUsesAddressForm,
  v as useCentraContext,
  ln as useCentraFetchSelection,
  Be as useCentraIsFreeOrder,
  Fr as useCentraPaymentAction,
  J as useCentraPaymentInitialize,
  V as useCentraPostPayment,
  W as useCentraReducerDispatch,
  ye as useCentraReducerState,
  re as useCentraSearchFunction,
  ar as useCentraSearchLoadPage,
  cr as useCentraSearchSetFacets,
  Ae as useCentraSelectedPaymentMethod,
  Yt as useCentraSelectedShippingMethodType,
  k as useCentraSelectionResponse,
  Ee as useCentraUpdatePaymentFields,
  Q as useRenderAfterChildren,
  U as useTrackOnce,
  on as validateCheckoutAddresses
};
//# sourceMappingURL=lib.es.js.map
